<template>
  <b-modal
    v-model="emailActive"
    :title="`${$t('email.popup.title')} ${typeTitle}  ${$t('email.popup.title_two')}`"
    centered
    size="xl"
  >
    <b-card>
      <b-row>
        <h-f-model-multi-taggable
          v-model="model"
          ressource="emails/templates"
          :base-url="notificationUrl"
          label="Modèle de l'email"
          :text-choices="['title']"
          additional-fields="object,text"
          :additional-request="`&category=${category}`"
          class="w-100"
          @inputDetailChoice="modelChoice = $event"
        ></h-f-model-multi-taggable>
      </b-row>
      <b-row>
        <h-f-model-multi-taggable
          v-model="emailForm.recipient"
          :submitted="submitted"
          :invalid="$v.emailForm.recipient.$error"
          :required="!$v.emailForm.recipient.required"
          :label="$t('email.popup.recipient')"
          class="w-100"
          taggable
          input-type="multi-select"
          ressource="contacts"
          :base-url="directoryUrl"
          :text-choices="['email', 'first_name', 'last_name']"
          value-choice="email"
          :init="false"
        />
        <!-- <b-col class="align-self-end d-flex justify-content-start">
          <h-b-action text="Cc" :positive="false" class="mr-2" @click.native="ccActive = !ccActive" />

          <h-b-action text="Cci" :positive="false" @click.native="cciActive = !cciActive" />
        </b-col>
        <h-f-model-multi-taggable
          v-if="ccActive === true"
          v-model="emailForm.cc"
          label="Cc"
          class="w-100"
          :taggable="true"
          input-type="multi-select"
          ressource="contacts"
          :base-url="directoryUrl"
          :text-choices="['first_name', 'last_name', 'email']"
        />
        <h-f-model-multi-taggable
          v-if="cciActive === true"
          v-model="emailForm.recipient"
          label="Cci"
          class="w-100"
          :taggable="true"
          input-type="multi-select"
          ressource="contacts"
          :base-url="directoryUrl"
          :text-choices="['first_name', 'last_name', 'email']"
        /> -->
      </b-row>
      <b-row>
        <h-f-fields
          v-model="emailForm.object"
          :label="$t('email.popup.object')"
          class="w-100"
          :submitted="submitted"
          :invalid="$v.emailForm.object.$error"
          :required="!$v.emailForm.object.required"
        />
      </b-row>
      <b-row class="mt-4">
        <h-f-fields
          v-model="emailForm.content"
          :submitted="submitted"
          :invalid="$v.emailForm.content.$error"
          :required="!$v.emailForm.content.required"
          class="w-100"
          input-type="ckeditor"
        />
      </b-row>
      <b-row class="mt-3">
        <b-dropdown variant="primary">
          <template #button-content>
            Choisir une donnée
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item v-for="(variable, index) in variables" :key="index" @click="addVariable(variable.key)">
            {{ variable.label }}
          </b-dropdown-item>
        </b-dropdown>
      </b-row>
      <!-- <b-row>
        <div class="form-container-input">
          <label>{{ $t('email.popup.attachments') }}</label>
        </div>
      </b-row>
      <vue-dropzone
        id="dropzone_video_1"
        ref="myVueDropzone"
        :use-custom-slot="true"
        :options="dropzoneOptions"
        @vdropzone-file-added="vfileAdded"
      >
        <div class="dropzone-custom-content">
          <i class="display-4 text-muted bx bx-cloud-download"></i>
          <h5>{{ $t('email.popup.files') }}</h5>
        </div>
      </vue-dropzone> -->
    </b-card>
    <template #modal-footer>
      <b-row class="d-flex justify-content-between w-100">
        <h-b-action class="mr-2" :text="$t('email.popup.return')" :positive="false" @click.native="cancelMail" />
        <h-b-action v-if="loadedPost" :text="$t('email.popup.send')" :positive="true" @click.native="sendEmail" />
        <h-e-spinner v-else size="sm" class="d-flex justify-content-end w-75 mt-0"></h-e-spinner>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import { Hk, FunctionHelpers } from '@/node-sdk'
import { required } from 'vuelidate/lib/validators'

const { Category } = Hk.Notif

const { SendTransaction } = Hk.Crm

export default {
  components: {
    // vueDropzone: vue2Dropzone,
  },

  props: {
    typeTitle: {
      type: String,
      default: '',
    },
    object: {
      type: Array,
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    category: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    defaultRecipients: {
      type: Array,
      default: () => [],
    },
  },

  validations: {
    emailForm: {
      recipient: { required },
      content: { required },
      object: { required },
    },
  },

  data() {
    return {
      model: null,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 30,
        thumbnailHeight: 100,
        resizeHeight: 100,
        maxFilesize: 4,
      },
      emailActive: false,
      emailForm: {
        recipient: this.defaultRecipients,
        object: null,
        content: null,
        file: [],
        cc: null,
        cci: null,
      },
      cciActive: false,
      ccActive: false,
      directoryUrl: process.env.VUE_APP_REPOSITORY,
      notificationUrl: process.env.VUE_APP_NOTIFICATIONS_API,
      modelChoice: null,
      variables: [],
      submitted: false,
      loadedPost: true,
    }
  },

  watch: {
    modelChoice() {
      if (this.modelChoice.object) {
        const model = this.modelChoice.object
        this.emailForm.object = model.object
        this.emailForm.content = model.text
        this.replaceVariables()
      } else {
        this.emailForm.object = null
        this.emailForm.content = null
      }
    },

    // eslint-disable-next-line func-names
    'emailForm.content': function () {
      this.replaceVariables()
    },
  },

  async mounted() {
    this.variables = (await Category.getById(this.category, { params: { expand: ['variables'] } })).variables
  },

  methods: {
    manageSendMail() {
      this.emailActive = !this.emailActive
    },

    async sendEmail() {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        FunctionHelpers.formErrorModal()
      } else {
        this.loadedPost = false
        await SendTransaction.create({
          data: this.emailForm.content,
          emails: this.emailForm.recipient,
          default: false,
          type: this.type,
          object: this.emailForm.object,
        })
        this.$emit('send')
        this.loadedPost = true
        this.emailActive = false
      }
    },

    cancelMail() {
      this.manageSendMail()
      this.emailForm = {}
    },

    vfileAdded(file) {
      const reader = new FileReader()
      reader.onload = (event) => {
        this.emailForm.file = event.target.result
      }
      reader.readAsDataURL(file)
    },

    addVariable(key) {
      const emailLength = this.emailForm.content.length
      this.emailForm.content =
        this.emailForm.content.slice(0, emailLength - 4) + key + this.emailForm.content.slice(emailLength - 4)
    },

    replaceVariables() {
      let text = this.emailForm.content
      Object.values(this.params).forEach((item) => {
        const reg = new RegExp(`{{${item.text}}}`, 'g')
        text = text.replace(reg, item.value ? item.value : '')
      })
      this.emailForm.content = text
    },
  },
}
</script>

<style scoped></style>
